import { render, staticRenderFns } from "./myModal.vue?vue&type=template&id=3608f82a&scoped=true&"
import script from "./myModal.vue?vue&type=script&lang=js&"
export * from "./myModal.vue?vue&type=script&lang=js&"
import style0 from "./myModal.vue?vue&type=style&index=0&lang=less&"
import style1 from "./myModal.vue?vue&type=style&index=1&id=3608f82a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3608f82a",
  null
  
)

export default component.exports